import types from 'actions/types'
import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'
import {InvoiceStatus} from 'helpers/invoices'
import {get} from 'lodash'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const invoicingContextPurchasingPivotTableKey = 'invoicingContext.purchasing.pivotTable'

export const status = (state = InvoiceStatus.AWAITING_POSTING.id, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default: return state
  }
}

export const companyId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS: return (action.filters.hasOwnProperty('companyId')) ? action.filters.companyId : state
    case types.CONTACTS_RECENTS_REMOVE: return state && state === action.companyId ? null : state
    case types.CONTACTS_RECENTS_CLEAR: return null  // not necessarily correct, but best guess
    default: return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default: return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const creatorId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.creatorId', state)
    default:
      return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, invoicingContextPurchasingPivotTableKey)
}

export default combineReducers({
  pivotTable: createPivotTableReducer({key: 'invoicingContext.purchasing.pivotTable',defaultSortColumn: 'desc'}),
  status,
  companyId,
  timeKey,
  targetStart,
  targetEnd,
  creatorId,
  total,
})
